import React from 'react';
import { PromoCountdown } from './PromoCountdown';
import { SALE_NAME } from '../data/promotion';
export function AnnouncementBar() {
  return <div className="w-full bg-grit-500 text-ink-950" data-id="element-9" data-mp="ollm9ibufdjl">
      <p className="mx-auto max-w-[1400px] px-4 py-2 text-center text-[11px] font-bold uppercase leading-tight tracking-[0.12em] sm:text-xs sm:tracking-[0.18em]" data-id="element-10" data-mp="jtbppjg83f8c">
        <span className="block sm:inline" data-id="element-11" data-mp="et63wjwmwmy6">
          <span aria-hidden="true" data-id="element-12" data-mp="9wyxkq0bt9fp">★ </span>
          {SALE_NAME} · 60% off · $49.95
        </span>
        <span className="mx-2 hidden sm:inline" data-id="element-13" data-mp="5t9bc774j3xu">•</span>
        <PromoCountdown compact className="mt-1 sm:mt-0" data-id="element-14" data-mp="5worldcjaj0u" />
        <span className="mx-2 hidden sm:inline" data-id="element-15" data-mp="w0se4e5ivvj">•</span>
        <span className="mt-1 block sm:mt-0 sm:inline" data-id="element-16" data-mp="3s1sgky8dbyfp">
          <span className="gold-plate inline-block px-2 py-0.5 tracking-[0.14em] text-ink-950 shadow-[0_6px_18px_-10px_rgba(212,160,23,0.9)]" data-id="element-17" data-mp="3s3daqmqrtfd1">
            Lifetime warranty free on every multi-pack
          </span>
        </span>
      </p>
    </div>;
}